import { render } from "./Results.vue?vue&type=template&id=c2b63266&scoped=true"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=c2b63266&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2b63266"

export default script